<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont0">{{
        titleHead + $t("newsAnncmnt.newsAnncmnt")
      }}</span>
    </p>
    <div class="main">
      <el-tabs v-model="activeName" type="card">
        <!-- 中文版 -->
        <el-tab-pane label="中文版" name="first">
          <EditCell ref="tabZhRef" :query="{ ...$route.query, data: formData0 }"
        /></el-tab-pane>
        <!-- 英文版 -->
        <el-tab-pane label="英文版" name="second">
          <EditCell ref="tabEnRef" :query="{ ...$route.query, data: formData1 }"
        /></el-tab-pane>
      </el-tabs>
      <!-- 按钮 -->
      <el-row class="foot-container">
        <!-- 返回 -->
        <el-button type="return" @click="returnPage()">{{
          $t("common.back")
        }}</el-button>
        <!-- 确定 -->
        <el-button style="margin-bottom: 30px" type="submit" @click="submit">{{
          $t("common.confirm")
        }}</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { build20Id } from "@/utils/buildId.js";
import EditCell from "./EditCell.vue";

export default {
  components: {
    EditCell
  },
  data() {
    let newsNo = build20Id();
    return {
      activeName: "first",
      formData0: {
        title: "",
        synopsis: "",
        content: "",
        coverLocationCode: build20Id(),
        newsNo: newsNo,
        language: "0"
      },
      formData1: {
        title: "",
        synopsis: "",
        content: "",
        coverLocationCode: build20Id(),
        newsNo: newsNo,
        language: "1"
      },
      titleHead: ""
    };
  },
  // 监听
  watch: {},
  methods: {
    async submit() {
      let formData0 = this.$refs.tabZhRef.$data.formData;
      let formData1 = this.$refs.tabEnRef.$data.formData;
      if (!formData0.title && !formData1.title) {
        // 请填写标题
        return this.$message({
          type: "error",
          message: this.$t("newsAnncmnt.msg3")
        });
      }
      if (formData0.synopsis && !formData0.title) {
        // 请填写中文标题
        return this.$message({
          type: "error",
          message: this.$t("newsAnncmnt.msg4")
        });
      }
      if (formData1.synopsis && !formData1.title) {
        // 请填写英文标题
        return this.$message({
          type: "error",
          message: this.$t("newsAnncmnt.msg5")
        });
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      await this.$refs.tabZhRef.submit();
      await this.$refs.tabEnRef.submit();
      let url = "/api/newsAnncmnt/reviseNewsAnncmnt";
      this.$http
        .post(url, [
          {
            ...formData0,
            updateUser: localStorage.userId,
            createUser: localStorage.userId
          },
          {
            ...formData1,
            updateUser: localStorage.userId,
            createUser: localStorage.userId
          }
        ])
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.$message({
              type: "success",
              message: this.$t("p0433.operationSuccess")
            });
            this.returnPage();
          }
        })
        .catch(error => {
          loading.close();
          console.log(error);
        });
    },
    // 返回
    returnPage() {
      this.$router.push({
        path: "/views/Asqms/views/NewsAnncmnt/Index",
        query: {
          ...this.$route.query
        }
      });
    }
  },
  mounted() {
    if (this.$route.query.titleHead) {
      this.titleHead =
        this.$route.query.titleHead === "add"
          ? this.$t("common.new")
          : this.$t("common.edit");
    }
    if (this.$route.query.id) {
      this.formData0.id = this.$route.query.id;
      this.formData0.newsNo = this.$route.query.newsNo;
      this.formData1.id = this.$route.query.id;
      this.formData1.newsNo = this.$route.query.newsNo;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 80%;
  margin: 0 auto;
  padding-top: 17px;
  // display: flex;
}

>>> .el-form-item {
  margin-bottom: 0%;
  text-align: left;
}

.couponType >>> .el-form-item__content {
  line-height: 30px;
}

.foot-container {
  margin: 40px auto 0 auto;
  height: 26px;
  text-align: center;
}

.noticeInputCenter >>> .el-input__inner {
  text-align: center;
  // font-size: 18px;
}

// 遮罩颜色
>>> .el-dialog__wrapper {
  background: rgba(88, 88, 88, 0.4);
}

>>> .el-dialog__body {
  color: #000000;
  font-family: sans-serif;
}

>>> .el-form-item__label {
  font-size: 16px;
  color: #2c3e50;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
  padding-left: 60px;
  padding-right: 60px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
  padding-left: 60px;
  padding-right: 60px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-color: #f2f2f2;
  background-color: rgb(246, 246, 246);
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  font-weight: 700;
  font-style: normal;
  color: #7f7f7f;
}
</style>



// WEBPACK FOOTER //
// src/views/Asqms/views/NewsAnncmnt/Edit.vue